import { FC, useCallback } from 'react';
import classNames from 'classnames';
import Utils from '../utils';
import { PreviewButton } from '../preview/PreviewButton';
import ProductCover from './ProductCover';

type Props = {
    readonly hoverListener?: (hovered: boolean) => void;
    readonly minimalView?: boolean;
    readonly product: any;
};

export const IssueProductTile: FC<Props> = ({ product, minimalView: minimalViewSelected = false, hoverListener }) => {
    const showDetails = useCallback(() => {
        hoverListener?.(true);
    }, [hoverListener]);

    const hideDetails = useCallback(() => {
        hoverListener?.(false);
    }, [hoverListener]);

    const shortenedTitle = Utils.truncate(product.title);
    const loanFormatClass = classNames('prd-tile', minimalViewSelected && 'minimal');

    return (
        <div className={loanFormatClass} onMouseLeave={hideDetails}>
            <div className="prd-tile-inner">
                <div className="packshot" data-displayname="ProductTile">
                    <ProductCover onMouseEnter={showDetails} minSizeInPx={300} product={product} />
                    <PreviewButton product={product} />
                </div>
                <h3>{shortenedTitle}</h3>
            </div>
        </div>
    );
};
